import { useParams } from 'react-router';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';

type Result = ModelHookResult<{
	canonicalUrl: string | undefined;
	description: string | undefined;
	displayName: string;
	image: string;
	searchFriendlyDescription: string;
	title: string;
}>;

export function usePageMeta(): Result {
	const { description, displayName, photo, title: role, slug } = useDecisionMakerProfilePageData();
	const { slug: urlParam } = useParams<{ slug: string }>();

	const { translate } = useI18n();

	const name = translate('corgi.decision_maker_profile.meta.description.name_label', {
		display_name: displayName,
	});
	const dmTitleIfExists = role
		? translate('corgi.decision_maker_profile.meta.description.title_label', { dm_title: role })
		: '';
	const pageSummary = translate('corgi.decision_maker_profile.meta.description.page_summary');
	const searchFriendlyDescription = [name, dmTitleIfExists, pageSummary].filter(Boolean).join('. ');

	const title = `${translate('corgi.decision_maker_profile.meta.page_title', {
		display_name: displayName,
	})}${role ? ` - ${role}` : ''}`;

	const isId = (paramValue: string | undefined) => paramValue !== undefined && /^[0-9]+$/.test(paramValue);
	const canonicalUrl = isId(urlParam) && slug !== null ? `https://www.change.org/decision-makers/${slug}` : undefined;

	return {
		data: {
			canonicalUrl,
			description: description ? description.slice(0, 150) : undefined,
			displayName,
			image: photo?.userLarge.url ?? 'https://static.change.org/images/default-petition.gif',
			searchFriendlyDescription,
			title,
		},
	};
}
